









































































import {Component, Vue, Watch} from 'vue-property-decorator'
import {HTTP} from '@/plugins/axios';

@Component
export default class Login extends Vue {
  private token: boolean = this.$store.state.auth.token
  private loading: boolean = false
  private data: object = {
    user: '',
    pass: ''
  }
  private errorLogin: boolean = false

  private errorLoginMSG: string = 'Por favor verifique el correo electronico y/o password.'

  private Login () {
    console.log('Login :: ', this.data)
    this.loading = true
    this.errorLogin = false
    HTTP.post('auth/login', this.data)
      .then((response) => {
        console.log('CreateBoleto :: response :: ', response.data)
        this.$store.commit('setAuth', response.data)
        this.$router.push({ path: '/boletos' })
      })
      .catch((e) => {
        console.log('CreateBoleto :: catch :: ', e.response.data)
        this.loading = false
        this.errorLogin = true
      })
  }
}
